const overworldTileset = {
  id: 'overworld_v1',
  name: 'Overworld',
  image: '/assets/tiles/tiles_v2.png',
  tileSize: 48,
  renderSize: 32,
  columns: 16,
  terrains: [
    {
      terrainId: 0,
      name: 'Tierra',
      walkable: true,
      autotile: false,
      frame: { x: 0, y: 0 }
    },
    {
      terrainId: 1,
      name: 'Carretera',
      walkable: true,
      autotile: true,
      autotileRow: 1,
      maskMap: 'road'
    },
    {
      terrainId: 2,
      name: 'Río',
      walkable: false,
      autotile: true,
      autotileRow: 2,
      maskMap: 'water'
    },
    {
      terrainId: 3,
      name: 'Muro',
      walkable: false,
      autotile: true,
      autotileRow: 3,
      maskMap: 'wall'
    },
    {
      terrainId: 4,
      name: 'Mar',
      walkable: false,
      autotile: true,
      autotileRow: 8,
      maskMap: 'water'
    },
    {
      terrainId: 5,
      name: 'Bosque',
      walkable: false,
      autotile: true,
      autotileRow: 5,
      maskMap: 'forest'
    },
    {
      terrainId: 6,
      name: 'Camino',
      walkable: true,
      autotile: true,
      autotileRow: 6,
      maskMap: 'road'
    },
    {
      terrainId: 7,
      name: 'Ciénaga',
      walkable: false,
      autotile: true,
      autotileRow: 4,
      maskMap: 'swamp'
    },
    {
      terrainId: 8,
      name: 'Montaña',
      walkable: false,
      autotile: false,
      frame: { x: 8, y: 0 }
    },
    {
      terrainId: 9,
      name: 'Puente',
      walkable: true,
      autotile: false,
      frame: { x: 10, y: 3 }
    },
    {
      terrainId: 10,
      name: 'Costa',
      walkable: true,
      autotile: false,
      frame: { x: 0, y: 4 }
    },
    {
      terrainId: 11,
      name: 'Lago Profundo',
      walkable: false,
      autotile: false,
      frame: { x: 0, y: 8 }
    },
    {
      terrainId: 12,
      name: 'Adoquín',
      walkable: true,
      autotile: false,
      frame: { x: 0, y: 7 }
    },
    {
      terrainId: 13,
      name: 'Bosque Denso',
      walkable: false,
      autotile: false,
      frame: { x: 0, y: 5 }
    },
    {
      terrainId: 14,
      name: 'Muralla Fortificada',
      walkable: false,
      autotile: false,
      frame: { x: 0, y: 3 }
    }
  ]
};

export default overworldTileset;
